"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_bootstrap_1 = require("react-bootstrap");

require("./SzCheckbox.scss");

function SzCheckbox(props) {
  var bgSecondary = props.bgSecondary,
      bgWarning = props.bgWarning,
      checked = props.checked,
      className = props.className,
      disabled = props.disabled,
      label = props.label,
      name = props.name,
      onChange = props.onChange,
      type = props.type,
      id = props.id;
  var formCheckClasses = classnames_1.default('sz-checkbox', className, {
    'ml-3': !bgSecondary && !bgWarning,
    checked: checked,
    bgWarning: bgWarning,
    bgSecondary: bgSecondary
  });

  if (bgWarning || bgSecondary) {
    return react_1.default.createElement(react_bootstrap_1.Form.Check, {
      name: name,
      className: "p-0"
    }, react_1.default.createElement(react_bootstrap_1.FormCheck, {
      className: formCheckClasses
    }, react_1.default.createElement("span", {
      className: "content d-inline-flex mr-2"
    }), react_1.default.createElement(react_bootstrap_1.FormCheck.Input, {
      id: id,
      className: "sz-custom-checkbox",
      disabled: disabled,
      type: type,
      checked: checked,
      onChange: onChange
    }), react_1.default.createElement(react_bootstrap_1.FormCheck.Label, null, label)));
  }

  return react_1.default.createElement(react_bootstrap_1.Form.Check, {
    custom: true,
    className: formCheckClasses,
    disabled: disabled,
    name: name,
    type: type,
    label: label,
    checked: checked,
    onChange: onChange,
    id: "sz-" + type + "-custom-" + label
  });
}

exports.default = SzCheckbox;
SzCheckbox.propTypes = {
  label: prop_types_1.default.node.isRequired,
  checked: prop_types_1.default.bool,
  type: prop_types_1.default.oneOf(['checkbox', 'radio'])
};